import moment from "moment";
import { auth, database } from "../firebase";

export const fetchCompanyInformation = async (details) => {
  try {
    if (details.organizationNumber) {
      const orgNumber = parseInt(
        details.organizationNumber.toString().replace(/ /g, "")
      );

      const request = await fetch(`/api/1881/details/${orgNumber}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      const trialEligible =
        moment(Date.now()).subtract(30, "day").unix() <
        moment(auth.currentUser.metadata.creationTime).unix();

      if (!response.error) {
        return {
          error: null,
          payload: {
            organizationNumber: orgNumber,
            uid: auth.currentUser.uid,
            trialEligible: trialEligible,
          },
        };
      } else {
        throw "Kunne ikke validere bedrift.";
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};
